import { FormItem, Input, Title } from '@vkontakte/vkui';
import { ChangeEvent, memo, useCallback } from 'react';

import { NominationsT } from 'src/entity/Pretendents';
import { IVotes } from 'src/shared/config';
import styles from './styles.module.scss';

interface IVoitingInputProps {
  name: NominationsT;
  label: string;
  onChange: (pretendent: IVotes) => void;
  firstStageVotes: IVotes;
}

export const VoitingInput = memo(
  ({
    name, label, onChange, firstStageVotes
  }: IVoitingInputProps) => {
    const onChangeHandler = useCallback(
      (name: string, e: ChangeEvent<HTMLInputElement>) => {
        const newPretendent = {
          [name]: e.currentTarget.value
        };
        onChange(newPretendent);
      },
      [onChange]
    );

    return (
      <FormItem key={name} className={styles.vote_card}>
        <Title className={styles.input_label} weight='3' level='2'>
          {label}
        </Title>
        <Input
          value={firstStageVotes[name] || ''}
          type='text'
          name={name}
          key={name}
          onChange={e => onChangeHandler(name, e)}
        />
      </FormItem>
    );
  }
);
